module.exports = __webpack_public_path__ + "img/prefeitura-ponta-grossa.726119e6.jpg";